import { string } from 'prop-types';
import React from 'react';

const ModalTitle = ({ title }) => {
	return (
		<div className="popup-tilte d-flex align-items-center">
			<h3 className="semibold-16 mb-0">{title}</h3>
		</div>
	);
};

ModalTitle.propTypes = {
	title: string.isRequired
};

export default ModalTitle;
